import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./_guards/auth.guard";
import { Guest } from "./_guards/guest.guard";
import { LoginPage } from "./pages/auth/login/login.page";
import { EmailForgotPasswordPage } from "./pages/auth/register/forgot-password/email-forgot-password/email-forgot-password.page";
import { ForgotPasswordPage } from "./pages/auth/register/forgot-password/forgot-password.page";
import { RegisterPage } from "./pages/auth/register/register.page";
import { VerifyCodePage } from "./pages/auth/register/verify-code/verify-code.page";
import { SplashComponent } from "./pages/splash/splash.component";
import { NetworkErrorComponent } from "./pages/network-error/network-error.component";


const routes: Routes = [
  {
    path: "",
    component: LoginPage,
    canActivate: [AuthGuard],
    data: {
      guest: true,
      status: false,
    },
  },
  {
    path: "network-error",
    component: NetworkErrorComponent,
  },
  {
    path: "login",
    component: LoginPage,
    canActivate: [Guest],
    data: {
      guest: true,
      connected: false,
      status: false,
    },
  },
  {
    canActivate: [Guest],
    data: {
      guest: true,
    },
    path: "register",
    component: RegisterPage,
  },
  {
    path: "verifier-numero-telephone",
    component: VerifyCodePage,
  },
  {
    path: "reintialiser-mot-de-passe",
    component: ForgotPasswordPage,
  },
  {
    path: "email-forgot-password",
    component: EmailForgotPasswordPage,
  },
  {
    path: "splash",
    component: SplashComponent,
  },

  {
    path: "particulier",
    loadChildren: () =>
      import("./pages/profiles/particulier/particulier.module").then(
        (m) => m.ParticulierModule
      ),
  },
  {
    path: "prestataire",
    loadChildren: () =>
      import("./pages/profiles/prestataire/prestataire.module").then(
        (m) => m.PrestataireModule
      ),
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
